import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  switchWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  divider: {
    "& .MuiDivider-root": {
      paddingBlock: 8,
    },
  },
  siteLogo: {
    width: 180,
    height: 180,
    objectFit: "cover",
    cursor: "pointer",
  },
  fieldWrapper: {
    paddingBlock: 8,
  },
  container: {
    paddingBlockStart: 16,
    padding: "10px",
  },

  btn: {
    display: "flex",
    justifyContent: "flex-end",
    paddingBlock: 12,
    "& .MuiButton-root": {
      padding: "6px 36px",
      backgroundColor: theme.palette.custom.main,
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ec7905",
      },
    },
  },
  cardContainer: {
    background: "#ffffff",
    boxShadow: "0px 5px 15px 5px rgba(0, 0, 0, 0.1)",
    borderRadius: 15,
    paddingBlock: 20,
    paddingInline: 20,
    marginBlock: 20,
  },
  password: {
    cursor: "pointer",
  },
  paymentModeContainer: {
    padding: "20px",
  },
  businessSettingsContainer: {
    padding: "20px",
  },
  editorWrapper: {
    padding: "20px 0px",
  },
}));

export default useStyles;
